import React from "react";
import { useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";
import { Breakdown, GitchaLink } from "@/components/ResultsParts";
import { foundYouRows, listingsRows, reachedYouRows } from "@/helpers/analyticsMerge";
import "./ResultsCombined.scss";

const footnotesOf = (gitcha) => {
  if (!gitcha) return [];
  return [
    gitcha.aiReads?.current
      ? "AI assistant reads are ChatGPT, Claude and Perplexity opening your public pages to answer someone's question. A read is not a recommendation."
      : null,
    gitcha.google ? "Google numbers come from Google Search Console and run about 2 days behind." : null,
  ];
};

const apartRowsOf = (gitcha) => {
  if (!gitcha) return [];
  const aiReads = gitcha.aiReads?.current || 0;
  const aiVisits = gitcha.aiVisits?.current || 0;
  return [
    aiReads || aiVisits ? { label: "Times AI assistants read your Buyer Want-Listings", value: aiReads, apart: true } : null,
    gitcha.google ? { label: "Times you showed up in Google results", value: gitcha.google.impressions.current, apart: true } : null,
  ];
};

const ResultsCombined = ({ bySource, days, networkName = "LAR", seeMore = true, bioHref = null }) => {
  const navigate = useNavigate();
  const found = foundYouRows(bySource, networkName);
  const reached = reachedYouRows(bySource);
  const listings = listingsRows(bySource);
  const period = `last ${days} days`;

  return (
    <div className="results-combined">
      <Breakdown
        title="Where they found you"
        subtitle={
          bySource.gitcha ? (
            <>
              Views and contacts by where they came from, including <GitchaLink href={bioHref}>Gitcha.com</GitchaLink>, {period}
            </>
          ) : (
            `Views and contacts by where they came from, ${period}`
          )
        }
        rows={[...found, ...apartRowsOf(bySource.gitcha)]}
        footnotes={footnotesOf(bySource.gitcha)}
        empty={<p className="results-combined__none">Nothing recorded in this period yet.</p>}
      />
      <Breakdown
        title="How they reached you"
        subtitle={`Introductions, messages and taps, ${period}`}
        rows={reached}
        seeMore={seeMore ? { label: "See more", onClick: () => navigate(pageURLs.agentMyClients) } : null}
        empty={<p className="results-combined__none">No one has reached out in this period yet.</p>}
      />
      {listings ? (
        <Breakdown
          title="Your listings and properties"
          subtitle={`Introductions you sent to ${networkName} agents' buyers, ${period}`}
          rows={listings}
          seeMore={seeMore ? { label: "See more", onClick: () => navigate(pageURLs.agentInventoryListing) } : null}
        />
      ) : null}
    </div>
  );
};

export default ResultsCombined;
